import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpInsuranceBenefitApprovalPaymentService } from './../../../service/http-insurance-benefit-payment-approval.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PolicyBenefitPaymentDto } from '../../../service/dto-insurance';
import { ResultListDto } from '../../../service/dto';
import { finalize, Subscription } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-benefit-payment-list',
	standalone: false,
	templateUrl: './benefit-payment-list.component.html',
	styleUrl: './benefit-payment-list.component.scss'
})
export class BenefitPaymentListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<PolicyBenefitPaymentDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();

	rejectionReason: string = '';
	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "ID", "property": "id" },
		{ "title": "Workflow", "property": "workflow.label" },
		{ "title": "Product", "property": "product.name" },
		{ "title": "Policy", "property": "policy.policyNumber" },
		{ "title": "From bank account", "property": "fromBankAccount.accountNumber" },
		{ "title": "Recipient: Bank Account", "property": "toBankAccount.accountNumber" },
		{ "title": "Recipient: Name", "cellRef": "beneficiaryRef" },
		{ "title": "Payment Date", "property": "scheduledPaymentDate" },
		{ "title": "Payment Amount", "cellRef": "benefitPaymentAmountRef" },
	];

	ticketReference: string = '';
	submitting: boolean = false;

	constructor(private httpService: HttpInsuranceBenefitApprovalPaymentService, private router: Router, private message: NzMessageService) {
	}
	ngOnInit(): void {
		this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doFetchUploads(input: OnTableChange) {
		this.loading = true;

		this.httpService.getCurrentPaymentFileEntries()
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = {
					list: result,
					totalItems: result.length,
					pageIndex: 1,
					pageSize: result.length,
					hashCode: 0
				};
			});
	}
	onSubmitPaymentFile(): void {
		this.submitting = true;
		this.httpService.doSendPaymentFileToBank().pipe(
			finalize(() => this.submitting = false)
		).subscribe({
			next: (response) => {
				this.message.success(`Payment file generated successfully`);
				this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
			},
			error: (err) => {
				this.message.error(err?.error?.message ?? 'Failed to generate payment file. Please try again.');
			}
		});
	}
	onSubmitPaymentLetter(): void {
		if (!this.ticketReference || this.submitting) return;

		this.submitting = true;

		this.httpService.doSendPaymentLetter(this.ticketReference).pipe(
			finalize(() => this.submitting = false)
		).subscribe({
			next: (response) => {
				this.message.success(`Payment file submitted successfully for ticket: ${this.ticketReference}`);
				this.ticketReference = '';
				this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
			},
			error: (err) => {
				this.message.error(err?.error?.message ?? 'Failed to submit payment file. Please try again.');
			}
		});
	}


}
